import React from 'react';

const CrossFill = () => {
  return (
    <svg
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 22.5C44 34.6503 34.1503 44.5 22 44.5C9.84973 44.5 0 34.6503 0 22.5C0 10.3497 9.84973 0.5 22 0.5C34.1503 0.5 44 10.3497 44 22.5ZM28.875 32.2919L27.4166 30.8333L22 25.4168L16.5834 30.8333L15.125 32.2919L12.2082 29.375L13.6666 27.9166L19.0832 22.5L13.6666 17.0834L12.2082 15.625L15.125 12.7082L16.5834 14.1666L22 19.5832L27.4166 14.1666L28.875 12.7082L31.7919 15.625L30.3333 17.0834L24.9168 22.5L30.3333 27.9166L31.7919 29.375L28.875 32.2919Z"
        fill="#E5484D"
      />
    </svg>
  );
};

export default CrossFill;
